import React from 'react';
import PropTypes from 'prop-types';
import DateFormatter from "../utils/DateFormatter";
import {I18nUtils} from "../../../i18n/I18nUtils";
import DocumentState from "./DocumentState";

export default class DocumentRow extends React.Component {

    render() {
        const {revision} = this.props;
        const expirationDateString = DateFormatter.formatDate(revision.end_date);
        return (
            <tr>
                <td><DocumentState state={revision.document_state}/></td>
                <td><strong>{revision.name}</strong></td>
                <td>{DateFormatter.formatDate(revision.start_date)}</td>
                <td>{expirationDateString ? expirationDateString : 'N/A'}</td>
                <td>
                    <a className={`btn btn-default btn-sm btn-block waves-effect ${!revision.files_zip_url ? 'disabled' : ''}`}
                       href={revision.files_zip_url} target="_blank">{I18nUtils.tr('TR_DOWNLOAD')}</a>
                </td>
            </tr>
        );
    }

}

DocumentRow.propTypes = {
    revision: PropTypes.objectOf(PropTypes.any).isRequired,
};

DocumentRow.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/DocumentRevisionRow.js